import React, { Component } from 'react';
import './App.css';
import Amplify, { API } from 'aws-amplify';
import aws_exports from './aws-exports';

import {
  Grid,
  Segment
} from 'semantic-ui-react'

import Calculator from './components/calculator';
import Crucibles from './components/crucibles';
import References from './components/references';
import Syncronicity from './components/syncronicity';
import MicrodosingMenu from './components/microdosingMenu';
import ModalFirstVisit from './components/modalFirstVisit';

Amplify.configure(aws_exports);

let apiName = 'sampleCloudApi';
let path = '/items';

class App extends Component {
  state = {
    route: 'calculator',
    width: 1000,
    height: 1000
  }

  componentDidMount(){
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    API.get(apiName, path).then(response => {});
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  render() {
    const { width, height, route} = this.state
    return (
      <Segment>
        <ModalFirstVisit />
        <MicrodosingMenu updateRoute={(route) => this.setState({route: route})} />
        <Grid>
          <Grid.Row>
            {this.props.width < 820 ?
              null:
              <Grid.Column width={3}>
              </Grid.Column>
            }
            <Grid.Column width={this.props.width < 820 ? 16 : 10}>
              { route === 'calculator' ? <Calculator width={width} height={height} /> : null }
              { route === 'references' ? <References width={width} height={height} /> : null }
              { route === 'crucibles' ? <Crucibles width={width} height={height} /> : null }
              { route === 'syncronicity' ? <Syncronicity width={width} height={height} /> : null }
              { route === 'subreddit' ? null : null }
            </Grid.Column>
            {this.props.width < 820 ?
              null:
              <Grid.Column width={3}>
              </Grid.Column>
            }
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js